import { h } from 'preact';
import { render } from '@testing-library/preact';
import userEvent from '@testing-library/user-event';
import { expect } from 'chai';
import { MessageCloseButton } from '@oracle/oraclejet-preact/UNSAFE_Message';

describe('Test MessageCloseButton component', () => {
  it('default renderer', async function () {
    const clickListenerObj = {
      clicked: false
    };
    const handleClick = function () {
      clickListenerObj.clicked = true;
    }
    const content = render(
      <MessageCloseButton
        onAction={handleClick}
      />
    );

    const button = await content.findByText('X');
    expect(button).not.null;

    userEvent.click(button);
    expect(clickListenerObj.clicked).to.be.true;
  });

  it('custom button renderer', async function () {
    const buttonRenderer = (
      title: string,
      onAction: (event?: Event) => void,
      _variant?: string) =>
    (
      <button
        style='background-color: orange;'
        aria-label={title}
        onClick={onAction}
        title={title}
      >{title}</button>
    );
    const clickListenerObj = {
      clicked: false
    };
    const handleClick = function () {
      clickListenerObj.clicked = true;
    }
    const content = render(
      <MessageCloseButton
        onAction={handleClick}
        buttonRenderer={buttonRenderer}
      />
    );

    const button = await content.findByText('Close');
    expect(button).not.null;
    expect(button.style.backgroundColor).to.equal('orange');

    userEvent.click(button);
    expect(clickListenerObj.clicked).to.be.true;
  });
});
